import { createPinia } from 'pinia';
import PrimeVue from 'primevue/config';
import { createApp } from 'vue';
import VueClickAway from 'vue3-click-away';
import { primevueConfig } from '../../config/primevue';
import App from './App.vue';
import { router } from './router';

export const initPay = () => {
  if (!document.getElementById('pay-app')) {
    return;
  }

  const pinia = createPinia();
  const app = createApp(App);

  app.config.globalProperties.$companyName = window.COMPANY_NAME;

  app.use(pinia)
    .use(router)
    .use(VueClickAway)
    .use(PrimeVue, primevueConfig);

  app.mount('#pay-app');
};
